import { baseUrl } from '@fs/zion-config'

export function buildUrl(url, external) {
  return `${external && !url.startsWith('https:') ? baseUrl : ''}${url}`
}
